import { SuperAdminConstants } from '../../../_constants';

const initialState = { removeAssessmentOrganisationLoading: true, data: '', error: false };

export function removeAssessmentOrganisationReducer(state = initialState, action) {

    switch (action.type) {
        case SuperAdminConstants.REQUEST_REMOVE_ASSESSMENT_ORGANISATION:
            return {
                removeAssessmentOrganisationLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_REMOVE_ASSESSMENT_ORGANISATION:
            return {
                removeAssessmentOrganisationLoading: false,
                data: action.removeAssessmentOrganisation,
                error: false
            };
        case SuperAdminConstants.REMOVE_ASSESSMENT_ORGANISATION_ERROR:
            return {
                removeAssessmentOrganisationLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/AddOrganisation/removeAssessmentOrganisation.reducer.js